import { ApiUrls } from '@/service/constants/urls';
import instance from '../Axios';
import { replaceLightframe } from '@/service/utils/replaceLightframe';
import { TTexts } from '@/domain/Texts.domain';

export const getTexts = async (partnerSlug: string): Promise<TTexts | undefined> => {
    try {
        if (partnerSlug.includes('.')) {
            return undefined;
        }

        const { data } = await instance.get<TTexts>(ApiUrls.texts.root, {
            params: {
                partnerId: replaceLightframe(partnerSlug),
            },
        });

        if (!data) {
            throw new Error(`[warn] No texts set for this partner!`);
        }

        return data;
    } catch (error) {
        return undefined;
    }
};
